/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminApiTestsIdStopPost$Params {
  id: string;
}

export function apiAdminApiTestsIdStopPost(http: HttpClient, rootUrl: string, params: ApiAdminApiTestsIdStopPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsIdStopPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminApiTestsIdStopPost.PATH = '/api/Admin/ApiTests/{id}/Stop';
